import React, { useState, useEffect } from 'react';
import { Link, useLocation }          from 'react-router-dom';
import { WHATSAPP_URL }               from '../utils/constants';
import { useWishlist }                from '../contexts/WishlistContext';
import { useCart }                    from '../contexts/CartContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState<boolean>(false);
  const location = useLocation();
  const { ids: wishlistIds } = useWishlist();
  const { totalCount: cartCount } = useCart();

  useEffect(() => {
    const onScroll = (): void => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  const isActive = (path: string): boolean =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner container">
        <Link to="/" className="nav-logo">
          <img src="/logo.png" alt="Balaji Fashion House" />
        </Link>

        <ul className="nav-links">
          <li><Link to="/"         className={isActive('/')         ? 'active' : ''}>Home</Link></li>
          <li><Link to="/products" className={isActive('/products') ? 'active' : ''}>Collections</Link></li>
          <li><Link to="/contact"  className={isActive('/contact')  ? 'active' : ''}>Contact</Link></li>
        </ul>

        <Link to="/wishlist" className="nav-icon-btn" aria-label={`Wishlist (${wishlistIds.length} items)`}>
          <i className="fa-solid fa-heart" aria-hidden="true" />
          {wishlistIds.length > 0 && <span className="nav-icon-badge">{wishlistIds.length}</span>}
        </Link>

        <Link to="/cart" className="nav-icon-btn" aria-label={`Basket (${cartCount} items)`}>
          <i className="fa-solid fa-basket-shopping" aria-hidden="true" />
          {cartCount > 0 && <span className="nav-icon-badge">{cartCount}</span>}
        </Link>

        <a href={WHATSAPP_URL()} target="_blank" rel="noreferrer" className="nav-whatsapp">
          💬 WhatsApp Us
        </a>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/">Home</Link>
          <Link to="/products">Collections</Link>
          <Link to="/wishlist">❤️ Wishlist{wishlistIds.length > 0 ? ` (${wishlistIds.length})` : ''}</Link>
          <Link to="/cart">🧺 Basket{cartCount > 0 ? ` (${cartCount})` : ''}</Link>
          <Link to="/contact">Contact</Link>
          <a href={WHATSAPP_URL()} target="_blank" rel="noreferrer">💬 WhatsApp Us</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
